import {
  CREATE_PHONE_CODE_SIGNIN,
  CREATE_PHONE_CODE_SIGNIN_SUCCESS,
  CREATE_PHONE_CODE_SIGNIN_FAILURE
} from './signinActions';

const initialState = {
  loading: false,
  createPhoneCodeSuccess: false
};

const signinReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'RESET_SIGNIN_REDUCER':
      return initialState;
    case CREATE_PHONE_CODE_SIGNIN:
      return {
        ...state,
        loading: true
      };
    case CREATE_PHONE_CODE_SIGNIN_SUCCESS:
      return {
        ...state,
        createPhoneCodeSuccess: true,
        loading: false
      };
    case CREATE_PHONE_CODE_SIGNIN_FAILURE:
      return {
        ...state,
        createPhoneCodeSuccess: false,
        loading: false
      };
    default:
      return state;
  }
};

export default signinReducer;
